/* eslint-disable import/prefer-default-export */
/* eslint import/no-unresolved: 0 */
import { useModel } from '@src/generic/model-store';
import { getCorrelationID } from '../../data/correlation';

/**
 * @typedef {Object} CohesionHandlers
 * @property { (action: string) => void } conversion - Sends a conversion tracking event.
 */

/**
 * Custom hook to handle Cohesion tracking events.
 *
 * @param {string} courseId The Current Course ID
 * @returns {CohesionHandlers}
 */
function useCohesion(courseId) {
  const { org: brand, title: name } = useModel('courseHomeMeta', courseId);

  const conversion = (action) => {
    if (!window.tagular) {
      return;
    }

    const id = getCorrelationID();
    const timestamp = new Date().toISOString();

    // The tagular function is the Cohesion API for sending events.
    // The tagular object is injected by the Cohesion script, which is loaded in by a wrapper component
    // (e.g. CohesionWrapper) in the app that uses this library.
    try {
      window.tagular('beam', {
        '@type': 'core.conversions.ConversionTracked.v2',
        correlation: { id },
        metadata: {
          category: 'Enrollment',
          action,
          timestamp,
          productList: [{
            brand,
            variant: 'courses',
            name,
          }],
        },
      });
    } catch (e) {
      console.error('Unable to track with Cohesion.', e.message); // eslint-disable-line no-console
    }
  };

  return {
    conversion,
  };
}

export {
  useCohesion,
};
